import { Button } from "./ui/button.jsx";
import { CheckCircle } from "lucide-react";

export default function Confirmation({ booking, onNewBooking }) {
  function formatMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  function formatDate(dateStr) {
    const d = new Date(`${dateStr}T12:00:00`);
    return d.toLocaleDateString("pt-PT", { dateStyle: "long" });
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <CheckCircle className="w-8 h-8 text-green-500" />
        <h2 className="text-2xl font-bold text-white">Marcação confirmada!</h2>
      </div>

      <dl className="space-y-4 mb-6">
        <div className="flex justify-between py-3 border-b border-border">
          <dt className="font-medium text-muted">Cliente</dt>
          <dd className="text-white">{booking.client_name}</dd>
        </div>
        <div className="flex justify-between py-3 border-b border-border">
          <dt className="font-medium text-muted">Profissional</dt>
          <dd className="text-white">{booking.hairdresser_name}</dd>
        </div>
        <div className="flex justify-between py-3 border-b border-border">
          <dt className="font-medium text-muted">Serviço</dt>
          <dd className="text-white">{booking.appointment_type_name}</dd>
        </div>
        <div className="flex justify-between py-3 border-b border-border">
          <dt className="font-medium text-muted">Data e hora</dt>
          <dd className="text-white text-right">
            {formatDate(booking.date)}<br />
            {formatMinutes(booking.start_minute)} - {formatMinutes(booking.end_minute)}
          </dd>
        </div>
      </dl>

      <p className="text-muted text-sm mb-6">
        Receberá um email de confirmação com o link de cancelamento.
      </p>

      <Button onClick={onNewBooking} className="w-full" size="lg">
        Nova marcação
      </Button>
    </div>
  );
}
